import { getCartShipments } from './get-cart-shipments';
import { getCartSummary } from './get-cart-summary';

export const Cart = {
  getCartShipments,
  getCartSummary,
};
